module.exports = [
  // Our villas
  {
    title: "our villas",
    linkId: 16,
    pageType: "page"
  },
  // Destinations
  {
    title: "Destinations",
    subheading: "regions",
    submenu: [
      {
        title: "Italy",
        submenu: [
          {
            title: "All Italy",
            linkType: "page",
            linkId: 89
          },
          {
            title: "Sicily",
            linkType: "page",
            linkId: 26
          },
          {
            title: "Puglia",
            linkType: "page",
            linkId: 28
          },
          {
            title: "Tuscany",
            linkType: "page",
            linkId: 1293
          }
        ]
      },
      {
        title: "Greece",
        submenu: [
          {
            title: "All Greece",
            linkType: "page",
            linkId: 1087
          },
          {
            title: "Aegina",
            linkType: "page",
            linkId: 1109
          },
          {
            title: "Alonissos",
            linkType: "page",
            linkId: 102
          },
          {
            title: "Antiparos",
            linkType: "page",
            linkId: 1119
          },
          {
            title: "Corfu",
            linkType: "page",
            linkId: 97
          },
          {
            title: "Evia",
            linkType: "page",
            linkId: 1115
          },
          {
            title: "Hydra",
            linkType: "page",
            linkId: 1116
          },
          {
            title: "Kastos",
            linkType: "page",
            linkId: 100
          },
          {
            title: "Kea",
            linkType: "page",
            linkId: 1150
          },
          {
            title: "Kefalonia",
            linkType: "page",
            linkId: 1124
          },
          {
            title: "Lefkada",
            linkType: "page",
            linkId: 101
          },
          {
            title: "Meganissi",
            linkType: "page",
            linkId: 99
          },
          {
            title: "Mykonos",
            linkType: "page",
            linkId: 1121
          },
          {
            title: "Paros",
            linkType: "page",
            linkId: 1120
          },
          {
            title: "Patmos",
            linkType: "page",
            linkId: 1210
          },
          {
            title: "Paxos and Antipaxos",
            linkType: "page",
            linkId: 98
          },
          {
            title: "Porto Heli",
            linkType: "page",
            linkId: 1126
          },
          {
            title: "Serifos",
            linkType: "page",
            linkId: 1205
          },
          {
            title: "Skiathos",
            linkType: "page",
            linkId: 1125
          },
          {
            title: "Skopelos",
            linkType: "page",
            linkId: 103
          },
          {
            title: "Spetses",
            linkType: "page",
            linkId: 1167
          },
          {
            title: "Syros",
            linkType: "page",
            linkId: 1122
          },
          {
            title: "Tinos",
            linkType: "page",
            linkId: 1123
          },
          {
            title: "Zakynthos",
            linkType: "page",
            linkId: 994
          }
        ]
      },
      {
        title: "France",
        submenu: [
          // {
          //   title: 'All France',
          //   linkType: 'page',
          //   linkId: 92,
          // },
          {
            title: "Corsica",
            linkType: "page",
            linkId: 30
          }
        ]
      }
    ]
  },
  // Experiences
  {
    title: "experiences",
    id: 2,
    submenu: [
      {
        title: "Experiences with soul",
        submenu: [
          {
            title: "Top Mediterranean adventures",
            linkType: "page",
            linkId: 1032
          },
          {
            title: "Mediterranean gastronomy",
            linkType: "page",
            linkId: 1033
          },
          {
            title: "Learn new skills",
            linkType: "page",
            linkId: 1036
          },
          {
            title: "Cultural holidays and activities",
            linkType: "page",
            linkId: 1037
          },
          {
            title: "Water sports and activities",
            linkType: "page",
            linkId: 1034
          },
          {
            title: "Wine-tasting experiences",
            linkType: "page",
            linkId: 1035
          },
          {
            title: "Explore all",
            linkType: "page",
            linkId: 40
          }
        ]
      }
      // {
      //   title: 'Unique experiences',
      //   submenu: [
      //     {
      //       title: 'Cookery retreat with C. Puglisi',
      //       linkType: 'page',
      //       linkId: 840,
      //     },
      //     {
      //       title: 'Cookery retreat with Michael Tusk',
      //       linkType: 'page',
      //       linkId: 1143,
      //     },
      //   ],
      // },
    ]
  },
  // Inspiration
  {
    title: "inspiration",
    mobileOnly: true,
    submenu: [
      {
        title: "Travel notes",
        submenu: [
          // {
          //   title: 'History and Culture',
          //   linkType: 'blog',
          //   linkId: 3137,
          //   url: '/blog/History-and-Culture',
          // },
          // {
          //   title: 'Food and Drink',
          //   linkType: 'blog',
          //   linkId: 3130,
          //   url: '/blog/Food-and-Drink',
          // },
          // {
          //   title: 'Inspiration',
          //   linkType: 'blog',
          //   linkId: 3186,
          //   url: '/blog/Inspiration',
          // },
          // {
          //   title: 'Resources',
          //   linkType: 'blog',
          //   linkId: 129,
          //   url: '/blog/Resources',
          // },
          // {
          //   title: 'Wellness and Relaxation',
          //   linkType: 'blog',
          //   linkId: 129,
          //   url: '/blog/Wellness-and-Relaxation',
          // },
          // {
          //   title: 'Activities and Adventure',
          //   linkType: 'page',
          //   linkId: 129,
          //   url: '/blog/Activities-and-Adventure',
          // },
          {
            title: "Explore our blog",
            linkType: "page",
            linkId: 1049,
            url: "/blog"
          }
        ]
      },
      {
        title: "Guides",
        submenu: [
          {
            title: "Sicily",
            linkType: "page",
            linkId: 33
          },
          {
            title: "Puglia",
            linkType: "page",
            linkId: 34
          },
          {
            title: "Tuscany",
            linkType: "page",
            linkId: 1293
          },
          {
            title: "Greece",
            linkType: "page",
            linkId: 1087
          },
          {
            title: "Corsica",
            linkType: "page",
            linkId: 36
          }
        ]
      },
      {
        title: "Collections",
        submenu: [
          {
            title: "Think Exquisite",
            linkType: "collection",
            linkId: 519
          },
          {
            title: "With a gate to the sea",
            linkType: "collection",
            linkId: 518
          },
          {
            title: "Family favourites",
            linkType: "collection",
            linkId: 9
          },
          {
            title: "A little place we know",
            linkType: "collection",
            linkId: 915
          }
        ]
      }
    ]
  },
  // Think exquisite
  {
    title: "think exquisite",
    linkId: 39,
    pageType: "page"
  },
  // About us
  {
    title: "about us",
    submenu: [
      {
        title: "Our story",
        linkId: 47,
        type: "page"
      },
      {
        title: "Why travel with us",
        linkId: 64,
        type: "page"
      },
      {
        title: "The Villa Matchmaker",
        linkId: 1264,
        type: "page"
      },
      {
        title: "Client reviews",
        linkId: 96,
        type: "page"
      },
      // {
      //   title: 'How to book',
      //   linkId: 44,
      //   type: 'page',
      // },
      {
        title: "Make an enquiry",
        linkId: 43,
        type: "page"
      },
      {
        title: "Contact us",
        linkId: 46,
        type: "page"
      },
      {
        title: "A responsible company",
        linkId: 1241,
        type: "page"
      },
      {
        title: "FAQ",
        linkId: 49,
        type: "page"
      }
    ]
  },
  // My account
  {
    title: "My account",
    linkId: 82,
    type: "page"
  }
];
